import { render } from "./filtrosStatusTrocaComponent.vue?vue&type=template&id=42eaa237&scoped=true"
import script from "./filtrosStatusTrocaComponent.vue?vue&type=script&lang=js"
export * from "./filtrosStatusTrocaComponent.vue?vue&type=script&lang=js"

import "./filtrosStatusTrocaComponent.vue?vue&type=style&index=0&id=42eaa237&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42eaa237"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QSelect,QItem,QItemSection,QItemLabel,QField});
